import { Injectable, ErrorHandler } from "@angular/core";
import {Log, LogTag} from "./Log";

@Injectable({
  providedIn: "root",
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error) {
    debugger;
    console.log(error.constructor.name)
    const logInfo = Log.getLogInfo("GlobalErrorHandler", "handleError", []);
    let msg = "";
    if (error instanceof TypeError) {
      msg = (<TypeError>error).message;
    } else  {
      try {
        msg = JSON.stringify(error);
      } catch (e) {
        msg = error;
      }
    }
    Log.e(logInfo, LogTag.GLOBAL_ERROR, msg);
  }
}
